<template>
    <div class="horse-list-search-criteria flex flex-wrap gap-3 mt-1 mb-4 p-3">
        <div class="flex gap-3 pr-3">
            <CustomSelectOneHorseStatus name="status" v-model="searchCriteria.horseStatus.value" :label="$t('message.horseList.status')" class="w-4"
                                        @update:modelValue="search"/>
            <CustomCalendar name="years" v-model="searchCriteria.years.value" :label="$t('message.horseList.year')" selectionMode="range"
                            :showTime="false" view="year" dateFormat="yy" :placeholder="$t('message.horseList.yearOrRange')" class="w-4" showButtonBar
                            @update:modelValue="search"/>
            <CustomInputText name="city" v-model="searchCriteria.city.value" :label="$t('message.horseList.city')" class="w-5"
                             @update:modelValue="search"/>
            <CustomSelectOneHorseOrigin name="origin" v-model="searchCriteria.origin.value" :label="$t('message.horseList.origin')" class="w-4"
                                        @update:modelValue="search"/>
        </div>
    </div>
</template>

<script>
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import CustomInputText from "@/components/form/CustomInputText.vue";
import CustomCalendar from "@/components/form/CustomCalendar.vue";
import CustomMultiSelectHorseColor from "@/components/form/CustomMultiSelectHorseColor.vue";
import CustomMultiSelectHorseSex from "@/components/form/CustomMultiSelectHorseSex.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomSelectOneYesNo from "@/components/form/CustomSelectOneYesNo.vue";
import CustomSelectOne from "@/components/form/inner/CustomSelectOne.vue";
import CustomSelectOneHorseStatus from "@/components/form/CustomSelectOneHorseStatus.vue";
import CustomCheckbox from "@/components/form/CustomCheckbox.vue";
import CustomSelectOneHorseOrigin from "@/components/form/CustomSelectOneHorseOrigin.vue";

export default {
    name: "HorseListSearchCriteria",
    components: {
        CustomSelectOneHorseOrigin,
        CustomCheckbox,
        CustomSelectOneHorseStatus,
        CustomSelectOne,
        CustomSelectOneYesNo,
        CustomButton,
        CustomMultiSelectHorseSex,
        CustomMultiSelectHorseColor,
        CustomCalendar,
        CustomInputText,
        Button,
        Column,
        DataTable,
    },

    props: {
        modelValue: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            imported: false,
            locallyBreed: false,
        };
    },

    computed: {
        searchCriteria: {
            get() { return this.modelValue; },
            set(value) { this.$emit("update:modelValue", value); },
        },
    },

    emits: ["update:modelValue", "search"],

    methods: {
        search() {
            this.$emit("search");
        },
    },

    watch: {
        locallyBreed(value) {
            // this.searchCriteria.origin
        },
        imported(value) {

        },
        searchCriteria: {
            handler(value) {
                this.$emit("update:modelValue", value);
            },
            deep: true,
        },
    },
};
</script>

<style lang="less" scoped>
.horse-list-search-criteria {
    background-color: var(--secondary-color);
    border-radius: 7px;
}
</style>
